<template>
    <div>
      <h1>Products</h1>
  
      <v-overlay v-if="syncing" z-index="998">
        <v-progress-circular indeterminate size="64" />
      </v-overlay>
      <v-row class="search">
        <v-text-field
          class="pt-3"
          placeholder="Search..."
          outlined
          clearable
          rounded
          v-model="searchTerm"
        ></v-text-field>
      </v-row>
      <v-btn
        color="primary"
        @click="syncProducts()"
        class="buttonStyle"
      >
        Sync
      </v-btn>
      <v-data-table
        v-if="products"
        :headers="headers"
        :items="products"
        :items-per-page="pageItems"
        :search="searchTerm"
        class="elevation-1 table datatable"
        :custom-filter="customSearch"
        :loading="loading"
        loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.title`]="{ item }">
          <v-row>
            <v-col cols="4" sm="2" md="1">
              <v-avatar size="50px">
                <img v-if="item.image" alt="Avatar" :src="item.image" />
              </v-avatar>
            </v-col>
  
            <v-col class="name">
              {{ item.title }}
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.price`]="{ item }">
          <v-row>
            <v-col class="ma-0 pb-0"> Rs. {{ item.selling_price }} </v-col>
          </v-row>
          <v-row>
            <v-col v-if="item.cost_price" class="ma-0 pt-0">
              Rs. {{ item.cost_price }}
            </v-col>
          </v-row>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize"> Reset </v-btn>
        </template>
      </v-data-table>

      <!--SNACKBAR FOR ERRORS-->
      <v-snackbar v-model="snackbar">
      {{ snackBarText }}

      <template>
        <v-btn color="secondary" text @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
    </div>
  </template>
    
    <script>
  import axios from "axios";
  import { BASE_URL } from "./baseUrl";
  /* eslint-disable */
  export default {
    name: "ProductView",
    data() {
      return {
        headers: [
          {
            text: "Product",
            align: "start",
            sortable: false,
            value: "title",
          },
          { text: "SKU", value: "sku", filterable: false },
          { text: "Price", value: "price", filterable: false },
          { text: "Quantity", value: "quantity", filterable: false },
        ],
        totalProducts: 0,
        products: null,
        pageItems: 10,
        page: 1,
        loading: true,
        product: null,
        syncing: false,
        searchTerm: null,
        snackbar: false,
      snackBarText: "",
      };
    },
    mounted() {
      this.syncing = true;
      let options = {
        headers: {
          "Access-Control-Allow-Headers":
            "X-Custom-Header, Access-Control-Request-Headers",
          "x-access-token": localStorage.getItem("token"),
          //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
        },
      };
      var url = BASE_URL + `products/`;
      axios
        .get(url, options)
        .then((response) => {
          console.log(response);
          this.products = response.data.products;
          this.totalProducts = response.data.totalCount;
          this.loading = false;
          this.syncing = false;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    methods: {
      getAllProducts() {
        this.syncing = true;
        let options = {
        headers: {
          "Access-Control-Allow-Headers":
            "X-Custom-Header, Access-Control-Request-Headers",
          "x-access-token": localStorage.getItem("token"),
          //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
        },
      };
      var url = BASE_URL + `products/`;
      axios
        .get(url, options)
        .then((response) => {
          console.log(response);
          this.products = response.data.products;
          this.totalProducts = response.data.totalCount;
          this.loading = false;
          this.syncing = false;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
      },
      customSearch (value, search, item) {
          let searchArr = search.split(" ");
          return searchArr.every(item => value.toLowerCase().includes(item.toLowerCase()));
        },
      editItem(item) {
        this.product = item;
        this.dialog = true;
      },
      
      
      syncProducts() {
        this.syncing = true;
        var url = BASE_URL + "products/sync";
        let options = {
          headers: {
            "Access-Control-Allow-Headers":
              "X-Custom-Header, Access-Control-Request-Headers",
            "x-access-token": localStorage.getItem("token"),
            //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
          },
        };
        axios
          .get(url, options)
          .then((response) => {
            console.log(response.data);
  
            if (response.data.hasError == true) {
              this.snackbar = true;
              this.snackBarText = response.data.message;
            } else if (response.status == 200) {
              this.snackbar = true;
              this.snackBarText = response.data;
              this.syncing = false;
              this.getAllProducts();
            }
          })
          .catch((error) => {
            console.log(error);
            this.errored = true;
          })
          .finally(() => (this.loading = false));
      },
      searchProduct() {
        var url = BASE_URL + `products/search?term=${this.searchTerm}`;
        let options = {
          headers: {
            "Access-Control-Allow-Headers":
              "X-Custom-Header, Access-Control-Request-Headers",
            "x-access-token": localStorage.getItem("token"),
            //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
          },
        };
        axios
          .get(url, options)
          .then((response) => {
            console.log(response);
            this.products = response.data.products;
            this.totalProducts = response.data.totalCount;
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            this.errored = true;
          })
          .finally(() => (this.loading = false));
      },
    }
  };
  </script>
  
  <style scoped>
  .name {
    margin-top: 3%;
    margin-left: 1%;
  }
  
  .costPrice {
    margin: 0;
    padding-top: 0;
  }
  
  .syncButton {
    margin-top: 2%;
    float: right;
  }
  
  .search {
    margin: 2%;
    
  }
  .buttonStyle {
    margin-top: -2%;
    float: right;
  }
  .datatable {
    margin-top: 3%;
  }
  </style>